import { render, staticRenderFns } from "./RequestPassword.vue?vue&type=template&id=326be6a0&scoped=true"
import script from "./RequestPassword.vue?vue&type=script&lang=js"
export * from "./RequestPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326be6a0",
  null
  
)

export default component.exports